import api from '~/services/api';
import { API_BASE_URL } from '~/constants';

class ClienteService {
  query(queryText, opts, config = {}) {

    const { vendedor = null } = config;

    const visualizaApenasClientesVinculados = vendedor?.visualizaApenasClientesVinculados ?? false;
    const fatVendedorId = vendedor?.id ?? null;

    const select = [
      'codigoInterno',
      'razaoSocial',
      'fantasia',
      'desativado',
      'mensagemVenda',
      'telefone',
      'celular',
      'enderecoComplemento',
      'enderecoUf',
      'enderecoCep',
      'enderecoLogradouro',
      'enderecoLogradouroNumero',
      'enderecoBairro',
      'pjCnpj',
      'pfCpf',
      'natureza',
      'id'
    ].join(',');
    const expand = [
      'enderecoIntCidade',
      'fatVendedor($select=id,nome)',
      'fatTabelavenda($select=id,descricao)',
      'intClienteGrupo($expand=fatTabelavenda($select=id,descricao))',
      'clienteMeioPagamento($select=id,finMeiopagamentoId,intClienteId)',
      'enderecos($expand=intCidade)'
    ].join(',');

    const consultaPorCodigo = /^\d+$/.test(queryText);
    let filter = '';

    if (queryText?.length >= 3) {
      const numero = Number(queryText);

      const filtros = ['pjCnpj', 'pfCpf', 'razaoSocial', 'fantasia']
        .map(field => `contains(${field}, %27${queryText.toUpperCase()}%27)`);

      if (numero) {
        filtros.push(
          `codigoInterno eq ${queryText.replace(/[&\/\\#,+()$~%.'":*?<>{}-]/g, '')}`
        );
      }

      filter = `(${filtros.join(' or ')})`;
    }

    if (consultaPorCodigo && queryText?.length < 3) {
      const codigo = `codigoInterno eq ${queryText.replace(/[&\/\\#,+()$~%.'":*?<>{}-]/g, '')}`;

      filter += `${filter ? ' or ' : ''}${codigo}`;
    }

    if (visualizaApenasClientesVinculados && fatVendedorId && filter) {
      filter += `${filter ? ' and ' : ''} fatVendedorId eq ${fatVendedorId}`;
    }

    if (filter) {
      return api.get(
        `${API_BASE_URL}/v1/consulta/cliente?$orderby=razaoSocial&$select=${select}&$filter=${filter}&$expand=${expand}`,
        opts
      );
    }
  }
}

export default new ClienteService();
